import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';
import {
  FETCH_RI_BY_SCENARIO_ID,
  fetchRIByScenarioIdSuccess,
  fetchRIByScenarioIdFail,
  PUT_RI_BY_SCENARIO_ID,
  putRIByScenarioIdSuccess,
  putRIByScenarioIdFail,
  FETCH_RI_LIST_BY_SCENARIO_ID,
  fetchRIListByScenarioIdSuccess,
  fetchRIListByScenarioIdFail
} from '../../redux/actions/trm/riskIndicators';

import * as api from '../../services/trm/trmServices';
const networkLayerObject = new api.NetworkLayer();

function* getRIListByScenarioId(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    let response = yield call(networkLayerObject.getRIByScenarioId, payload);

    yield put(fetchRIListByScenarioIdSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(fetchRIListByScenarioIdFail({ error }));
  }
}

export function* watchGetRIListByScenarioId() {
  yield takeEvery(FETCH_RI_LIST_BY_SCENARIO_ID, function* ({ payload }) {
    yield fork(getRIListByScenarioId, payload);
  });
}

function* getRIByScenarioId(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(networkLayerObject.getRIByScenarioId, payload);
    yield put(fetchRIByScenarioIdSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(fetchRIByScenarioIdFail({ error }));
  }
}

export function* watchGetRIByScenarioId() {
  yield takeEvery(FETCH_RI_BY_SCENARIO_ID, function* ({ payload }) {
    yield fork(getRIByScenarioId, payload);
  });
}

function* putRIByScenarioId(payload) {
  try {
    const response = yield call(networkLayerObject.putRIByScenarioId, payload);
    yield put(putRIByScenarioIdSuccess(response));
  } catch (error) {
    yield put(putRIByScenarioIdFail(error?.message));
  }
}

export function* watchPutRIByScenarioId() {
  yield takeEvery(PUT_RI_BY_SCENARIO_ID, function* ({ payload }) {
    yield fork(putRIByScenarioId, payload);
  });
}
